import React from 'react';
import _ from 'lodash';

const IntlContext = React.createContext({
  currency: () => '',
  date: () => ''
});

const currencyMap = {
  'en-US': 'USD',
  'en-CA': 'CAD',
  'fr-CA': 'CAD',
  'pt-BR': 'BRL'
};

let fractionDigits = 0;

const getCurrencyFormatter = locale => {
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: _.get(currencyMap, locale, 'USD'),
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
      trailingZeroDisplay: 'stripIfInteger'
    });
  } catch (e) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: _.get(currencyMap, locale, 'USD'),
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
      trailingZeroDisplay: 'stripIfInteger'
    });
  }
};
export class IntlProvider extends React.Component {
  constructor(props) {
    super(props);
    const { language, country } = this.props;
    const locale = `${language}-${country}`;
    fractionDigits = country === 'CA' ? 2 : 0;
    const currencyFormatter = getCurrencyFormatter(locale);
    const formatDate = value => {
      const date = new Date(value);

      const formatter = new Intl.DateTimeFormat(locale, {
        month: locale === 'pt-BR' ? 'short' : 'long',
        year: 'numeric',
        day: 'numeric'
      });

      if (locale === 'pt-BR' && formatter.formatToParts) {
        return formatter
          .formatToParts(date)
          .map(x => (x.type === 'literal' ? '/' : x.value))
          .join('');
      }
      return formatter.format(date);
    };
    this.intlContext = {
      currency: currencyFormatter.format,
      date: formatDate
    };
  }

  render() {
    return (
      <IntlContext.Provider value={this.intlContext}>
        {this.props.children}
      </IntlContext.Provider>
    );
  }
}

export default IntlContext;
